<template functional>
  <div class="footer-address">
    <h3 class="footer-address__heading">
      Kontakt
    </h3>

    <address>
      <el-row :gutter="32">
        <el-col :sm="12">
          Landesinstitut für Qualifizierung und Qualitätsentwicklung in Schulen<br>
          Felix-Dahn-Straße 3<br>
          20357 Hamburg
        </el-col>

        <el-col :sm="12">
          <a
            class="footer-address__link"
            href="tel:+4940428842671"
          >
            Tel.: +49 (0) 40 42 88 42 671
          </a><br>
          <a
            class="footer-address__link"
            href="mailto:organisation-lif24@li.hamburg.de"
          >
            organisation-lif24@li.hamburg.de
          </a>
        </el-col>
      </el-row>
    </address>
  </div>
</template>

<script>
export default {
  name: 'AFooterAddress'
}
</script>

<style lang="scss" scoped>
.footer-address {
  margin-bottom: 1em;
}

.footer-address__heading {
  margin: 0;

  font-size: 1em;
  color: $--color-primary;
}

.footer-address__link {
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: underline;
  }
}
</style>
